var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",attrs:{"height":!_vm.isResponsive ? 500 : ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }